import moment from "moment";
import { getWeekDaysFromDateRange } from "@/utils/dates";
import { cutString } from "@/utils/stringFormat";
import { DEFAULT_NO_IMAGE } from "@/consts/default-no-image";
import Loader from "@/components/loader/Loader.vue";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {
  name: "AdHocActivitiesReport",
  data() {
    return {
      period: "month",
      startDate: moment().subtract(1, "month").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      timeFormat: null,
      flexHeight: 250,
      loading: false,
      picker: {
        start: false,
        end: false
      },
      periods: [],
      headers: [],
      jsonFields: {
        "Type": "type",
        "Resident": "residentName",
        "StartDate": "startDisplay"
      },

      activitiesByHour: [],
      activitiesByDate: [],
      dailyCount: [],
    }
  },
  components: {
    Loader
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    report() {
      this.loading = false
      return this.$store.state.adHocActivitiesModule.adHocActivitiesReportData;
    },
    formattedSelectedDateRange() {
      return `${moment(this.startDate).format(this.facility.dateFormat)} - ${moment(this.endDate).format(this.facility.dateFormat)}`
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
  },
 
  async created() {
    this.getActivitiesByDates()
    this.timeFormat = this.facility.timeFormat.includes('A')?'hh  A':'HH'
    this.headers = [
      { text: "", value: "imageUrl", sortable: false },
      { text: this.$i18n.messages[this.$i18n.locale]["Reports.ActivitiesReport.ActivityType"], value: "type" },
      { text: this.$i18n.messages[this.$i18n.locale]["Reports.ActivitiesReport.Resident"], value: "residentName" },
      { text: this.$i18n.messages[this.$i18n.locale]["Reports.ActivitiesReport.StartDate"], value: "startDisplay" },
    ]
    this.periods = [
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
      { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
    ]
  },
  watch: {
    "report"(report) {
      this.activitiesByDate = this.groupByDay(report.activities)
      this.dailyCount = this.getDailyCount(report.activities)
      this.activitiesByHour = this.groupByHour(report.activities)
    }
  },
  methods: {
    async changeCurrentFacility(id) {
      this.$store.dispatch('setIsChangingFacilityOnCurrentBrowser', true);
      await this.$store.dispatch('changeCurrentUserFacility', { newFacilityId: id, redirectEnabled: false })
    },
    routeToReports() {
      this.$router.push("/reports");
    },
    routeToLifestyleResidentsReport() {
      this.$router.push("/reports/residntsAdHocActivitiesReport")
    },
    getActivitiesByDates() {
      this.loading = true
      this.$store.dispatch("getAdHocActivitiesReportData", {
        startDate: moment(this.startDate).startOf('day').toDate(),
        endDate: moment(this.endDate).endOf('day').toDate()
      });
    },
    getDailyCount(activities) {
      const types = activities.reduce(function (totals, event) {
        const date = moment(event.start)
          .startOf("day")
          .format("YYYY-MM-DD");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
  
      return types;
    },
    groupByDay(activities) {
      const weekDays = getWeekDaysFromDateRange(moment(this.startDate), moment(this.endDate))
      const week = weekDays.reduce((o, key) => ({ ...o, [key]: undefined }), {})
      const types = activities.reduce(function (totals, event) {
        const dayOfWeek = moment(event.start).format("dddd");
        !week[dayOfWeek] ? (week[dayOfWeek] = 1) : (week[dayOfWeek] = totals[dayOfWeek] + 1);
        return week;
      }, {});
      return types;
    },
    groupByHour(activities) {
      const timeFormat = this.timeFormat
      const types = activities.reduce(function (totals, event) {

        const dayOfWeek = moment(event.start).format(timeFormat);

        !totals[dayOfWeek]
          ? (totals[dayOfWeek] = 1)
          : (totals[dayOfWeek] = totals[dayOfWeek] + 1);
        return totals;
      }, {});
      return types;
    },
    handleChangePeriod(period) {
      this.startDate = moment()
        .subtract(1, period)
        .toISOString()
        .substring(0, 10);

      this.endDate = moment()
        .toISOString()
        .substring(0, 10);

      //reload report
      this.getActivitiesByDates()
    },
    truncateResidentName(name) {
      return cutString(name, 16);
    },
    getActivityImage(imageUrl) {
      return imageUrl && !imageUrl.includes("no-image") ? imageUrl : DEFAULT_NO_IMAGE;
    },
    chartMessages(): any {
      return { empty: this.$t('GeneralTranslations.NoData') };
    }
  }
}